import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { setCookie } from '../../functions/Auth';

import '../../scss/_styles.scss';
import '../../scss/components/_externalLayers.scss';

const DataPointLayers = (props) => {

    const [defaultOp, setDefaultOp] = useState(true);
    const [laneGeometryOp, setLaneGeometryOp] = useState(false);
    const [capacityOp, setCapacityOp] = useState(false);
    const [capacityAMOp, setCapacityAMOp] = useState(false);
    const [capacityMIDOp, setCapacityMIDOp] = useState(false);
    const [capacityPMOp, setCapacityPMOp] = useState(false);
    const [showColors, setShowColors] = useState(false);

    const handleDefaultOp = () => {
        if (!defaultOp === false)
            return ;
        setDefaultOp(!defaultOp);
        props.handleToggleDefaultLayer(!defaultOp);
        props.returnMainLIstPanel();
        setLaneGeometryOp(false)
        setCapacityOp(false);
        setCapacityAMOp(false);
        setCapacityMIDOp(false);
        setCapacityPMOp(false);
    }
    const handlelaneGeometryOp = () => {        
        setLaneGeometryOp(!laneGeometryOp);
        setCapacityOp(false);
        setCapacityAMOp(false);
        setCapacityMIDOp(false);
        setCapacityPMOp(false);
        if (!laneGeometryOp === false){
            setDefaultOp(true);
            props.handleToggleDefaultLayer(true);
            props.returnMainLIstPanel();
            return ;
        }
        props.handleToggleLaneGeometryLayer(!laneGeometryOp);
        props.returnMainLIstPanel();
        setDefaultOp(false);        
    }
    const handlecapacityOp = () => {
        setCapacityOp(!capacityOp);
        setLaneGeometryOp(false);  
        setCapacityAMOp(true);
        setCapacityMIDOp(false);
        setCapacityPMOp(false);
        if (!capacityOp === false){
            setDefaultOp(true);
            props.handleToggleDefaultLayer(true);
            props.returnMainLIstPanel();
            return ;
        }
        setDefaultOp(false);
        props.handleToggleCapacityLayer(!capacityOp, "am");
        props.returnMainLIstPanel();
    }
    const handlecapacityAMOp = () => {
        if (!capacityAMOp === false)
            return ;
        setCapacityAMOp(!capacityAMOp);
        props.handleToggleCapacityLayer(capacityOp, "am");
        setCapacityMIDOp(false);
        setCapacityPMOp(false);
    }
    const handlecapacityMIDOp = () => {
        if (!capacityMIDOp === false)
            return ;
        setCapacityMIDOp(!capacityMIDOp);
        props.handleToggleCapacityLayer(capacityOp, "mid");
        setCapacityAMOp(false);
        setCapacityPMOp(false);
    }
    const handlecapacityPMOp = () => {
        if (!capacityPMOp === false)
            return ;
        setCapacityPMOp(!capacityPMOp);
        props.handleToggleCapacityLayer(capacityOp, "pm");
        setCapacityAMOp(false);
        setCapacityMIDOp(false);
    }

    return (
        <>
        {                    
            props.showDataPointLayers &&
            <div data-testid="externalLayersContainer" className="main-data-point-layers-container">
                {
                    !showColors &&
                    <>
                        <p>DataPoint layers</p>
                        <IconButton aria-label="delete" className='btn-close-xtl' onClick={props.handleShowDataPointLayersContainer}>
                            <img src={require("../../assets/icons/close-external-leyer.svg")} />
                        </IconButton>
                        {/* <SortableList items={itemsLayer} distance={5} onSortEnd={onSortEnd} /> */}
                        <div className="main-layers-list" data-testid="layersList">
                            <div className="data-point-element-container">
                                <label class="switch">
                                    <input type="checkbox" checked={defaultOp} onChange={handleDefaultOp} />
                                    <span class="slider round"></span>
                                </label>
                                <label className="data-point-element-title">
                                    Default
                                </label>
                            </div>
                            {
                                defaultOp &&
                                <div className="data-point-indicators-container">
                                    <div className="data-point-indicators-element">
                                        <img src={require("../../assets/icons/marker_Midblock.svg")} />
                                        <label>
                                            Midblock
                                        </label>
                                    </div>
                                    <div className="data-point-indicators-element">
                                        <img src={require("../../assets/icons/marker_Intersection.svg")} />
                                        <label>
                                            Intersection
                                        </label>
                                    </div>
                                </div>
                            }
                            <div className="data-point-element-container">
                                <label class="switch">
                                    <input type="checkbox" checked={laneGeometryOp} onChange={handlelaneGeometryOp} />
                                    <span class="slider round"></span>
                                </label>
                                <label className="data-point-element-title">
                                    Lane geometry
                                </label>
                            </div>
                            {
                                laneGeometryOp &&
                                <div className="data-point-indicators-container">
                                    <div className="data-point-indicators-element">
                                        <img src={require("../../assets/icons/map_pin_int.svg")} />
                                        <label>
                                            Set
                                        </label>
                                    </div>
                                    <div className="data-point-indicators-element">
                                        <img src={require("../../assets/icons/not_set.svg")} />
                                        <label>
                                            Not Set
                                        </label>
                                    </div>
                                </div>
                            }
                            <div className="data-point-element-container">
                                <label class="switch">
                                    <input type="checkbox" checked={capacityOp} onChange={handlecapacityOp} />
                                    <span class="slider round"></span>
                                </label>
                                <label className="data-point-element-title">
                                    Capacity
                                </label>
                            </div>
                            {
                                capacityOp &&
                                <div className="data-point-indicators-container">
                                    <div className="data-point-indicators-element">
                                        <input type="checkbox" id="period_am" name="am" value="am" checked={capacityAMOp} onChange={handlecapacityAMOp}/>
                                        <label class="inner" for="period_am"></label>
                                        <label class="outer" for="period_am">AM</label>
                                    </div>
                                    <div className="data-point-indicators-element">
                                        <input type="checkbox" id="period_mid" name="mid" value="mid" checked={capacityMIDOp} onChange={handlecapacityMIDOp}/>
                                        <label class="inner" for="period_mid"></label>
                                        <label class="outer" for="period_mid">MID</label>
                                    </div>
                                    <div className="data-point-indicators-element">
                                        <input type="checkbox" id="period_pm" name="pm" value="pm" checked={capacityPMOp} onChange={handlecapacityPMOp}/>
                                        <label class="inner" for="period_pm"></label>
                                        <label class="outer" for="period_pm">PM</label>
                                    </div>
                                    <div className="data-point-indicators-element">
                                        <img src={require("../../assets/icons/not_set.svg")} />
                                        <label>
                                            No scenarios
                                        </label>
                                    </div>
                                    <div className="data-point-indicators-element">
                                        <img src={require("../../assets/icons/under_capacity.svg")} />
                                        <label>
                                            Under capacity
                                        </label>
                                    </div>
                                    <div className="data-point-indicators-element">
                                        <img src={require("../../assets/icons/near_capacity.svg")} />
                                        <label>
                                            Near capacity
                                        </label>
                                    </div>
                                    <div className="data-point-indicators-element">
                                        <img src={require("../../assets/icons/over_capacity.svg")} />
                                        <label>
                                            Over capacity
                                        </label>
                                    </div>
                                </div>
                            }
                        </div>
                    </>
                }
            </div>
        }
        </>
    )

}

export default DataPointLayers;